import styled from '@emotion/styled';

import { JsonError } from '@d-id/types';

import { ERROR_KINDS } from '../components/GenerateAvatar';
import { DEFAULT_AVATAR_CREATION_ERROR, ERROR_TEXT_BY_KIND } from '../constants';

const List = styled.ul`
    list-style-type: disc;
    padding-left: 1.5rem;
`;

export const getErrorTextByKind = (error?: JsonError): React.ReactNode => {
    const errorKindsAsStringArray: string[] = Object.values(ERROR_KINDS) as string[];
    if (!error || !error.kind || !errorKindsAsStringArray.includes(error.kind)) {
        return DEFAULT_AVATAR_CREATION_ERROR;
    }

    if (error.kind === ERROR_KINDS.TrainingValidationError && error.details?.errors) {
        return (
            <div>
                Errors:
                <List>
                    {error.details.errors.map((error: string, index: number) => (
                        <li key={index}>{error}</li>
                    ))}
                </List>
                Please upload new footage and try again.
            </div>
        );
    } else if (error.kind === ERROR_KINDS.AlgoRequestError) {
        return (
            <div>
                <List>
                    <li>{error.description}</li>
                </List>
            </div>
        );
    }

    const validErrorKind = error.kind as ERROR_KINDS;

    return ERROR_TEXT_BY_KIND[validErrorKind];
};
